import React, { useState } from 'react'
import PasswordInputField from "../PasswordInputField";
import ConfirmPasswordInputField from "../ConfirmPasswordInputField";
import { Navigate,useNavigate,useParams } from 'react-router-dom';
import {changePassword} from '../config/Variables';
import Header from '../partials/Header';

function ChangePassword(){
 // const [email, setEmail] = useState();
 var element = document.getElementById("header-react");
 if(element){
  element.classList.add("hide");
  }
  const [old_password, setCurrentPassword] = useState();
  const [password, setPassword] = useState();
  const [messagelog, setMessagelog] = useState("");
  const [errormesg, setErrormesg] = useState("");


  const navigate = useNavigate();
  //const [device_name, setDevice] = useState();
  const device_name = 'nokia';
  async function simpleregister() {
  
    if(old_password!=="" && errormesg==''  && passwordInput.confirmPassword===passwordInput.password  && password===passwordInput.password){  
      if (localStorage.getItem('user-info')) {
        let user = JSON.parse(localStorage.getItem('user-info'));
      let item = { old_password, password, device_name };
    let result = await fetch(changePassword, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json',
        "Authorization":"Bearer "+user.token.access_token,
      },
      body: JSON.stringify(item)
    });

    result = await result.json();

    if(result.message.code =='200'){
      //navigate('/change_password');
    setMessagelog(result.message.message);
    } 
    else{
     // navigate('/registersimple');
     setMessagelog(result.message.message);
    }
  }
    //history('/add');
  }else{
    setMessagelog('الرجاء تأكد انك ادخلت جميع الخانات قبل التسجيل');
  }
  }


const [passwordError, setPasswordErr] = useState("");
const [confirmPasswordError, setConfirmPasswordError] = useState("");
const [passwordInput, setPasswordInput]= useState({
    password:'',
    confirmPassword:''
})
const handlePasswordChange =(evnt)=>{
    const passwordInputValue = evnt.target.value.trim();
    const passwordInputFieldName = evnt.target.name;
    const NewPasswordInput = {...passwordInput,[passwordInputFieldName]:passwordInputValue}
    setPasswordInput(NewPasswordInput);
   // setPassword(NewPasswordInput);
    
}
const handleValidation= (evnt)=>{
    const passwordInputValue = evnt.target.value.trim();
    const passwordInputFieldName = evnt.target.name;
        //for password 
if(passwordInputFieldName==='password'){
    const uppercaseRegExp   = /(?=.*?[A-Z])/;
    const lowercaseRegExp   = /(?=.*?[a-z])/;
    const digitsRegExp      = /(?=.*?[0-9])/;
    const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
    const minLengthRegExp   = /.{8,}/;
    const passwordLength =      passwordInputValue.length;
    const uppercasePassword =   uppercaseRegExp.test(passwordInputValue);
    const lowercasePassword =   lowercaseRegExp.test(passwordInputValue);
    const digitsPassword =      digitsRegExp.test(passwordInputValue);
    const specialCharPassword = specialCharRegExp.test(passwordInputValue);
    const minLengthPassword =   minLengthRegExp.test(passwordInputValue);
    let errMsg ="";
    if(passwordLength===0){
      errMsg="الرجاء ادخال كلمة المرور";
      setErrormesg(errMsg);
    }else if(!digitsPassword){
      errMsg="رقم واحد على الأقل";
      setErrormesg(errMsg);
    }else if(!minLengthPassword){
      errMsg="8 أحرف على الأقل";
      setErrormesg(errMsg);
    }else{
    errMsg="";
    setErrormesg(errMsg);
    }
    setPasswordErr(errMsg);
    }
    // for confirm password
    if(passwordInputFieldName=== "confirmPassword" || (passwordInputFieldName==="password" && passwordInput.confirmPassword.length>0) ){
            
        if(passwordInput.confirmPassword!==passwordInput.password)
        {
        setConfirmPasswordError("تأكيد كلمة المرور غير متطابق");
        }else{
        setConfirmPasswordError("");
        setPassword(passwordInput.password);
        }
        
    }
}
if (!localStorage.getItem('user-info')) {
    
  return <Navigate to="/" />

}else{
  return(
    <>
<Header backhref="#/editprofile"  />
      <div>
      <div className="grid-x align-center">
        <div className="cell shrink">
          <div className="return-btn hide-for-large">
           
          </div>
          <div className="form-area-wrap padding-vertical-3">
            <div className="section-title margin-bottom-2">
              <h3>تغيير كلمة المرور</h3>
             
              <p>قم بادخال كلمة المرور الحالية والجديدة</p>
              <div className="message alert text-center">
              {messagelog}
            </div>
            </div>
            <div className="message alert text-center ">
              
            </div>
            <div className="form-area">
          
                  <div className="input-field">
                    <span className="ico-label"><i className="icomoon-icon icon-lock"></i></span>
                    <input type="password" name="currentpassword" required="required" placeholder="كلمة المرور الحالية"  onChange={(e) => setCurrentPassword(e.target.value)}  />
                    <div class="required">*</div>
            
                  </div>

                
                        
          
                <PasswordInputField 
                handlePasswordChange={handlePasswordChange} 
                handleValidation={handleValidation} 
                passwordValue={passwordInput.password} 
                passwordError={passwordError}/>
                <ConfirmPasswordInputField 
                handlePasswordChange={handlePasswordChange} 
                handleValidation={handleValidation} 
                confirmPasswordValue={passwordInput.confirmPassword} 
                confirmPasswordError={confirmPasswordError}/>
            
                <button onClick={simpleregister} className="button submit-btn" > تغيير كلمة المرور </button>
            
            </div>
          </div>
        </div>
      </div>


    </div>
</>
    
    )
}
}
export default ChangePassword;